import React, { useState, useEffect } from "react";
import "./puja-campaign-output.scss";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";

import { createImage } from "@/customHooks/campaign/durgaPuja2025/createImage";

import OutputLoader from "@/components/pujaCampaign2025/output/output-loader";
import Btn from "../btn";
import PujaCampaignDownload from "../download";
import ShareOptions from "../download/shareOptions";

// import cameraFrame from "@/../public/campaign/puja-2025/camera-frame.png";
import outputFrame from "@/../public/campaign/puja-2025/output-frame.png";

const toastOptions = {
  position: "top-left",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
};

export default function Output({
  onNextComp,
  capturedImg,
  userId,
  bgId,
  gender,
  params,
}) {
  const {
    userId: userIdFromParams,
    bgId: bgIdFromParams,
    txnId,
    status,
    gender: genderFromParams,
  } = params;

  const router = useRouter();
  const [outputImg, setOutputImg] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isShowDownload, setIsShowDownload] = useState(false);
  const [showShareOptions, setShowShareOptions] = useState(false);
  const [isDownloadLoading, setIsDownloadLoading] = useState(false);

  // Create image when all params are available or data is in the app state
  useEffect(() => {
    if (status === "failed") {
      console.error("payment failed redirecting to home");
      onNextComp("payment");
      return;
    }

    if (
      ((userIdFromParams || userId) &&
        (bgIdFromParams || bgId) &&
        (genderFromParams || gender) &&
        capturedImg) ||
      txnId
    ) {
      const handleCreateImage = async () => {
        const data = {
          userId: userIdFromParams || userId,
          bgId: bgIdFromParams || bgId,
          txnId,
          userImgDataUri: capturedImg?.img,
          gender,
        };
        // console.log(data);
        const result = await createImage(data);

        if (result?.error) {
          toast.error(result?.error, toastOptions);
          setTimeout(() => {
            onNextComp("payment");
          }, 3000);
          return;
        }

        if (result) {
          setOutputImg({ url: result.outputImg, id: result._id });
          setTimeout(() => {
            setIsLoading(false);
          }, 3000);
        } else {
          toast.error(
            "Something went wrong, please try after some time.",
            toastOptions
          );
          setTimeout(() => {
            onNextComp("home");
          }, 3000);
        }
      };
      handleCreateImage();
    }
  }, [params]);

  // download image
  const downloadImage = async (url, name) => {
    try {
      /*  console.log(url);

      const response = await fetch(url, {
        mode: "cors",
      });

      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = name || "download.jpg";
      document.body.appendChild(link); // For Firefox
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl); // Clean up */

      saveAs(url, name);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div className="flex-col-center PujaCampaignOutput">
      <h1 className="pageHeading">
        {!isLoading ? "DOWNLOAD READY!" : "PLEASE WAIT"}
      </h1>

      <div className="flex-row-center outputImgContainer">
        {outputImg?.url && (
          <Image
            src={outputImg?.url}
            alt="captured image"
            className="uploadImg"
            width={720}
            height={720}
            loading="lazy"
            style={!outputImg && isLoading ? { filter: "blur(8px)" } : ""}
          />
        )}
        <Image
          src={outputFrame}
          alt="camera"
          className="cameraFrame"
          width={720}
          height={720}
        />
        {isLoading && (
          <div className="flex-row-center userImgOverlay">
            <OutputLoader />
          </div>
        )}
      </div>

      <div className="flex-col-center btnContainer">
        {!isLoading && (
          <Btn
            btnTxt={"DOWNLOAD"}
            // onClick={() => setIsShowDownload(true)}
            onClick={() => {
              setIsDownloadLoading(true);
              downloadImage(
                outputImg?.url,
                `snapshawt-durga-puja-blessing-${outputImg?.id || Date.now()}`
              );
              setTimeout(() => {
                setIsDownloadLoading(false);
              }, 3000);
            }}
            isLoading={isDownloadLoading}
            isBigBtn={false}
          />
        )}

        {!isLoading && (
          <Btn
            btnTxt={"SHARE"}
            onClick={() => {
              setShowShareOptions(true);
            }}
            isLoading={false}
            isBigBtn={false}
          />
        )}

        {!isLoading && (
          <Btn
            btnTxt={"RETRY"}
            onClick={() => onNextComp("home")}
            isLoading={false}
            isBigBtn={false}
          />
        )}
      </div>

      {isShowDownload && (
        <PujaCampaignDownload
          userId={userId}
          setIsShowDownload={setIsShowDownload}
        />
      )}

      {showShareOptions && (
        <ShareOptions
          setShowShareOptions={setShowShareOptions}
          url={outputImg?.url}
        />
      )}
    </div>
  );
}
